<template>
	<div class="sendBox" >
        <input id='msgInputBox' type="text" placeholder="message (tip: enter is faster)" autocomplete="off" tabindex="1" 
        v-model="message"    
        @keyup.enter="confirmSend"
        />
        <button class="smooth-trans" @click="confirmSend">Send</button>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'sendBox',
    data: function(){
        return{
            message:``
        }
    },
    methods:{
        confirmSend(){
            if(this.message != ``){
                this.$emit('send-message',{
                    message:this.message,
                    status:this.$store.state.userStatus,
                    userName:this.$store.state.userName,
                    date:this.generateDatetime()
                });
                this.message=``;
            }
        },
        generateDatetime(){
            // Compose an UTC datetime format like '2019-05-25 16:36:13'
            let date = new Date();
            date = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
            let result='';
            result=date.getFullYear().toString()+'-';
            if((date.getMonth()+1).toString().length==1)result+='0';
            result+=(date.getMonth()+1).toString()+'-';
            if(date.getDate().toString().length==1)result+='0';
            result+=date.getDate().toString()+' ';
            if(date.getHours().toString().length==1)result+='0';
            result+=date.getHours().toString()+':';
            if(date.getMinutes().toString().length==1)result+='0';
            result+=date.getMinutes().toString()+':';
            if(date.getSeconds().toString().length==1)result+='0';
            result+=date.getSeconds().toString();
            // alert(result);
            return result
        }
    }
}
</script>

<style scoped>
    .sendBox {
        z-index: 1;
        position: fixed;
        height:48px;
        width: 100vw;
        bottom:0;
        left:0;
        background-color: white;
        box-shadow: 0 -1px 1px rgba(0, 0, 0, 0.2),0 0 ;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-radius: 8px 8px 0 0;
    }

    .sendBox input{
        margin-left:12px;
        border: none;
        background-color: white;
        outline:none;
        line-height: 42px;
        font-size: 24px;
        order: 0;
        flex-grow: 9;
        margin-right: 6px;
    }

    .sendBox button {
        height: 40px;
        /* width: 72px; */
        border-radius: 8px;
        border: none;
        color:white;
        background-color: #25a23b;
        font-weight: 600;
        font-size: 16px;
        outline:none;
        /* box-shadow: 0 3px 4px rgba(0, 0, 0, 0.6),0 0 ; */
        order: 1;
        flex-grow: 2;
        padding-left: 3px;
        padding-right: 3px;
        margin-right:6px;
    }

    .sendBox button:active {
        color:rgba(255, 255, 255, 0.8);
        background-color: rgb(85, 214, 108); /* rgb(14, 138, 196); */
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3),0 0 ;
    }
</style>
